import React, { useState } from 'react';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import {
  Paper,
  Stack,
  Button,
  Switch,
  TextField,
  Typography,
  Autocomplete,
  CircularProgress,
  FormControlLabel,
} from '@mui/material';

interface Props {
  canWrite: boolean;
  availableVendors: any;
  selectedVendor: any[];
  setSelectedVendor: any;
  isPartnerAccount: boolean;
  isPartnerLinksLoading: boolean;
}

export const VendorSection = ({
  canWrite,
  selectedVendor,
  isPartnerAccount,
  availableVendors,
  setSelectedVendor,
  isPartnerLinksLoading,
}: Props) => {
  const [isShowOnlyActive, setIsShowOnlyActive] = useState<boolean>(true);

  const availableVendorsOptions = availableVendors.filter((vendor: any) => (isShowOnlyActive ? vendor.isActive : true));

  return (
    <Paper sx={{ padding: '1rem' }}>
      <Stack gap="0.5rem">
        <Stack direction="row" alignItems="center" gap="0.5rem">
          <Typography variant="subtitle1" color="primary">
            <LooksOneIcon /> {isPartnerAccount ? 'Dealer' : 'Aftermarket Vendor'}
          </Typography>

          <RenderWithCondition condition={isPartnerLinksLoading}>
            <CircularProgress size={20} />
          </RenderWithCondition>
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" gap="0.5rem">
          <Autocomplete
            fullWidth
            multiple
            size="small"
            options={availableVendorsOptions}
            getOptionLabel={option => option.label}
            disabled={!canWrite || isPartnerLinksLoading}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            onChange={(event, newValues) => setSelectedVendor(newValues)}
            value={availableVendors.filter((vendor: any) => selectedVendor.find(sv => sv.value === vendor.value))}
            renderInput={params => (
              <TextField
                {...params}
                required
                variant="outlined"
                label={`Select the ${isPartnerAccount ? 'Dealers that have access to this product' : 'Vendor'}`}
              />
            )}
          />

          <RenderWithCondition condition={isPartnerAccount}>
            <Button
              variant="contained"
              sx={{ minWidth: '6rem' }}
              onClick={() => setSelectedVendor(availableVendorsOptions)}
              disabled={!canWrite || isPartnerLinksLoading || !availableVendorsOptions.length}
            >
              Add All
            </Button>
          </RenderWithCondition>
        </Stack>

        <RenderWithCondition condition={isPartnerAccount}>
          <FormControlLabel
            label="Show only active"
            control={
              <Switch
                checked={isShowOnlyActive}
                disabled={!canWrite}
                onChange={e => {
                  setIsShowOnlyActive(e.target.checked);
                }}
              />
            }
          />
        </RenderWithCondition>
      </Stack>
    </Paper>
  );
};
